module.exports = __webpack_public_path__ + "assets/165e7bde16115e659172ef20bdd05116.png";